// extracted by mini-css-extract-plugin
export default {"wrapper":"PreviewLayout_wrapper__jkh4i","tablet":"PreviewLayout_tablet__37Oi0","mobile":"PreviewLayout_mobile__WazWF","main":"PreviewLayout_main__yqvEc"};